import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import api_call from '../../../globals/common_utilities/axios_old';
import CONSTANTURL from '../../../globals/common_utilities/constanturls';
// import { handleActions } from "redux-actions";
import { API } from '../../../globals/constants';

const initialState = {
	loading: false,
	Response: [],
	error: '',
	add_feedback: [],
	getFeedbackById: [],
	updateFeedback: [],
};
export const revertAll = createAsyncThunk('something');
export const someSlice = createSlice({
	name: 'something',
	initialState,
	reducers: {
		resetState(state) {
			state.add_feedback = [];
			state.loading = false;
		},
	},
});

export const ReduxFeedback = createAsyncThunk(
	'feedback/ReduxFeedback',
	({ token, params }) => {
		return api_call(
			token,
			'post',
			'https://45nqltb6r4.execute-api.ap-south-1.amazonaws.com/dev/api/v1/view-feedback-response',
			{},
			{},
			params
		);
	}
);

const loginSlic = createSlice({
	name: 'feedback',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(ReduxFeedback.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(ReduxFeedback.fulfilled, (state, action) => {
			state.loading = false;
			state.Response = action.payload;
			state.error = '';
		});
		builder.addCase(ReduxFeedback.rejected, (state, action) => {
			state.loading = false;
			state.Response = [];
			state.error = action.error.message;
		});
	},
});
export const AdminAddFeedback = createAsyncThunk(
	'createFeedback/api',
	({ bodyParam, endPoints }) => {
		console.log('check api', bodyParam);
		return api_call(
			'post',
			`${CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK + endPoints}`,
			{},
			{},
			bodyParam
		);
	}
);
const AdminAddFeedbackSlice = createSlice({
	name: 'createFeedback',
	initialState,
	extraReducers: (builder) => {
		{
			console.log('check it----------');
		}
		builder.addCase(AdminAddFeedback.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(AdminAddFeedback.fulfilled, (state, action) => {
			{
				console.log('check it----------2');
			}
			state.loading = false;
			state.add_feedback = action.payload;
			state.error = '';
		});
		builder.addCase(AdminAddFeedback.rejected, (state, action) => {
			{
				console.log('check it----------3');
			}
			state.loading = false;
			state.add_feedback = [];
			state.error = action.error.message;
		});
	},
});
export const getFeedbackById = createAsyncThunk(
	'createFeedback/api',
	({ params, endPoints }) => {
		return api_call(
			'get',
			`${CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK + endPoints}`,
			params,
			{},
			{}
		);
	}
);
const getFeedbackByIdSlice = createSlice({
	name: 'createFeedback',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(getFeedbackById.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(getFeedbackById.fulfilled, (state, action) => {
			state.loading = false;
			state.getFeedbackById = action.payload;
			state.error = '';
		});
		builder.addCase(getFeedbackById.rejected, (state, action) => {
			state.loading = false;
			state.getFeedbackById = [];
			state.error = action.error.message;
		});
	},
});
export const updateFeedback = createAsyncThunk(
	'updateFeedback/api',
	({ params, bodyParam, endPoints }) => {
		console.log('checkdata-----', params, bodyParam, endPoints);
		return api_call(
			'post',
			`${CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK + endPoints}`,
			params,
			{},
			bodyParam
		);
	}
);
const updateFeedbackSlice = createSlice({
	name: 'updateFeedback',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(updateFeedback.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(updateFeedback.fulfilled, (state, action) => {
			state.loading = false;
			state.updateFeedback = action.payload;
			state.error = '';
		});
		builder.addCase(updateFeedback.rejected, (state, action) => {
			state.loading = false;
			state.updateFeedback = [];
			state.error = action.error.message;
		});
	},
});

export const feedbackReducer = {
	feedbackReducer: loginSlic.reducer,
	adminaddfeedback: AdminAddFeedbackSlice.reducer,
	getFeedbackById: getFeedbackByIdSlice.reducer,
	updateFeedback: updateFeedbackSlice.reducer,
	someReducer: someSlice.reducer,
};
